import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import { BaseComponent } from '../classes/BaseComponent';
import { AuthenticationService } from '../authentication.service';
import { Global } from '../classes/Global';
import { StorageHelper } from '../helpers/StorageHelper';
import { ValidationHelper } from '../helpers/ValidationHelper';
import { BaseService } from '../classes/BaseService';
import { Log } from '../helpers/Log';

@Component({
  selector: 'app-change-email',
  templateUrl: './change-email.component.html',
  styleUrls: ['./change-email.component.scss'],
  providers: [ AuthenticationService ]
})
export class ChangeEmailComponent extends BaseComponent implements OnInit {

  shaObj: any;
  email: string = "";
  confirmEmail: string = "";

  invalidEmail: boolean = false;
  emailChangeSuccess: boolean = false;
  serverError: boolean = false;
  serverMessage: string = "";

  @Output() onAuthFail = new EventEmitter();
  @Output() close = new EventEmitter();

  constructor(private authenticationService: AuthenticationService) {
    super();
  }

  ngOnInit() {
  }

  onEmailChange(email) {
    this.email = email;
  }

  onConfirmEmailChange(email) {
    this.confirmEmail = email;
  }

  changeEmail() {

    this.serverError = false;
    this.emailChangeSuccess = false;

    if(!ValidationHelper.isValidString(this.email) || !ValidationHelper.isValidString(this.confirmEmail) ||
    !ValidationHelper.isValidEmail(this.email) || this.email != this.confirmEmail){
      this.invalidEmail = true;
      return;
    }

    this.invalidEmail = false;

    this.authenticationService.changeMail(Global.getCountry(),
    StorageHelper.getInstance().get(StorageHelper.keys.sessionToken), this.email).subscribe(res => {
      if(res && res["status"] == "success") {
        this.emailChangeSuccess = true;
      }
      else if(res && res["message"] == BaseService.COULDNT_LOAD_USER) {
        StorageHelper.getInstance().clear(StorageHelper.keys.sessionToken);
        this.onAuthFail.emit();
      }
      else {
        this.serverError = true;
        this.serverMessage = res["message"];
      }

    }, err => {
      Log.getInstance().d(err);
    });
  }

}
